import { DATA_STATE_CHECKED, DATA_STATE_SELECTED, DATA_STATE_INDETERMINATE, } from '../constants';
import { getUi as getGlobalUi } from './icons.global';
export default function getIcons() {
    const globalUi = getGlobalUi();
    return Object.freeze({
        action: {
            show: { value: globalUi.chevronRight },
            edit: { value: globalUi.pencil },
            openExternal: { value: globalUi.arrowBox },
            back: { value: globalUi.arrowLeft },
            close: { value: globalUi.cross },
            dismiss: { value: globalUi.cross },
            openDatepicker: { value: globalUi.calendar },
            callToAction: { value: globalUi.arrowRight },
            previous: { value: globalUi.chevronLeft },
            next: { value: globalUi.chevronRight },
            retry: { value: globalUi.circularArrows },
            delete: { value: globalUi.trashCan },
            add: { value: globalUi.plusCircle },
            download: { value: globalUi.arrowDownLine },
            filter: { value: globalUi.filter },
            clear: { value: globalUi.cross },
        },
        feedback: {
            negative: { value: globalUi.alert },
            positive: { value: globalUi.checkmark },
            informative: { value: globalUi.information },
            warning: { value: globalUi.information },
            cancelled: { value: globalUi.cross },
            completed: { value: globalUi.checkmark },
        },
        form: {
            checkbox: {
                dataStates: {
                    [DATA_STATE_CHECKED]: { value: globalUi.checkmark },
                    [DATA_STATE_INDETERMINATE]: { value: globalUi.minusCenter },
                },
            },
            select: {
                open: { value: globalUi.chevronDown },
            },
            information: { value: globalUi.information },
            datepicker: {
                switchView: { value: globalUi.chevronDown },
            },
        },
        listItem: {
            dataStates: {
                [DATA_STATE_SELECTED]: { value: globalUi.checkmark },
            },
        },
    });
}
